import { redirectToHomeIfLoggedIn, redirectToSignUpIfNotGoogleLoggedIn } from './guards'

export default [
  {
    path: '/',
    name: 'welcome',
    component: () => import('@/views/Login.vue'),
    beforeEnter: redirectToHomeIfLoggedIn,
    meta: {
      layout: 'FiftyFifty',
    },
  },
  {
    path: '/sign-up',
    name: 'signUp',
    component: () => import('@/views/registration/SignUp.vue'),
    beforeEnter: redirectToHomeIfLoggedIn,
    meta: {
      layout: 'FiftyFifty',
    },
  },
  {
    path: '/complete-profile',
    name: 'createProfile',
    component: () => import('@/views/registration/CompleteProfile.vue'),
    beforeEnter: redirectToSignUpIfNotGoogleLoggedIn,
    meta: {
      layout: 'Default',
      shouldLogOutOnGoBack: true,
    },
  },
  {
    path: '/verify-email',
    name: 'verifyEmail',
    component: () => import('@/views/registration/VerifyEmail.vue'),
    meta: {
      layout: 'Default',
      shouldLogOutOnGoBack: true,
    },
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'FiftyFifty',
      success: true,
    },
  },
  {
    path: '/password-reset',
    name: 'passwordReset',
    component: () => import('@/views/registration/PasswordReset.vue'),
    meta: {
      layout: 'Default',
    },
  },
  {
    path: '/check-your-inbox',
    name: 'checkYourInbox',
    component: () => import('@/views/registration/CheckYourInbox.vue'),
    meta: {
      layout: 'Default',
    },
  },
  {
    path: '/install-client',
    name: 'install-client',
    component: () => import('@/views/InstallClient.vue'),
    meta: {
      layout: 'Default',
    },
  },
  {
    path: '/invites/accept/(.*)',
    name: 'invites-accept',
    component: () => import('@/views/AcceptInvite.vue'),
    meta: {
      layout: 'Default',
      shouldHideGoBack: true,
    },
  },
  {
    path: '/sub-entrustments',
    name: 'sub-entrustments',
    component: () => import('@/views/registration/SubEntrustments.vue'),
    meta: {
      layout: 'Default',
    },
  },
  {
    path: '/login',
    redirect: '/',
  },
  {
    path: '/shared-link/(.*)',
    name: 'shared-link',
    component: () => import('@/views/sharedFile/SharedBrowser.vue'),
    meta: {
      layout: 'Default',
      shouldHideGoBack: true,
    },
  },
]
